import React, { useState } from "react";
import "./HTML_MAIN_CSS.css";

const HTML_Quiz = () => {
  const quizQuestions = [
    {
      question: "What does HTML stand for?",
      options: [
        "Hyper Text Markup Language",
        "Home Tool Markup Language",
        "Hyperlinks and Text Markup Language",
        "Hyperlinking Text Management Language"
      ],
      answer: "Hyper Text Markup Language",
    },
    {
      question: "Which HTML element is used for the largest heading?",
      options: ["<h1>", "<h6>", "<heading>", "<head>"],
      answer: "<h1>",
    },
    {
      question: "Which attribute is used to provide an alternate text for images?",
      options: ["alt", "src", "title", "longdesc"],
      answer: "alt",
    },
    {
      question: "Which HTML element is used to create a hyperlink?",
      options: ["<a>", "<link>", "<href>", "<hyperlink>"],
      answer: "<a>",
    },
    {
      question: "Which tag is used to create a table row in HTML?",
      options: ["<tr>", "<td>", "<th>", "<row>"],
      answer: "<tr>",
    },
    {
      question: "Which element is used to create an unordered list?",
      options: ["<ul>", "<ol>", "<li>", "<list>"],
      answer: "<ul>",
    },
    {
      question: "Which tag is used to define a paragraph in HTML?",
      options: ["<p>", "<para>", "<paragraph>", "<text>"],
      answer: "<p>",
    },
    {
      question: "What is the correct HTML element for inserting a line break?",
      options: ["<br>", "<break>", "<lb>", "<line>"],
      answer: "<br>",
    },
    {
      question: "Which HTML element defines the title of the document?",
      options: ["<title>", "<head>", "<header>", "<meta>"],
      answer: "<title>",
    },
    {
      question: "Which HTML attribute specifies an inline CSS style?",
      options: ["style", "class", "id", "css"],
      answer: "style",
    },
    {
      question: "Which input type defines a checkbox?",
      options: ["checkbox", "radio", "text", "button"],
      answer: "checkbox",
    },
    {
      question: "Which element is used for embedding a video?",
      options: ["<video>", "<movie>", "<media>", "<play>"],
      answer: "<video>",
    },
    {
      question: "What does the `<em>` element do?",
      options: ["Emphasizes text", "Creates a bold text", "Adds a line break", "Defines a paragraph"],
      answer: "Emphasizes text",
    },
    {
      question: "Which element is used to define a section in HTML5?",
      options: ["<section>", "<div>", "<article>", "<span>"],
      answer: "<section>",
    },
    {
      question: "Which HTML element is used to define a footer for a document or section?",
      options: ["<footer>", "<bottom>", "<foot>", "<section-footer>"],
      answer: "<footer>",
    },
  ];

  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [selectedOption, setSelectedOption] = useState("");
  const [feedback, setFeedback] = useState("");
  const [score, setScore] = useState(0);
  const [showResult, setShowResult] = useState(false);

  const handleOptionChange = (option) => {
    setSelectedOption(option);

    if (option === quizQuestions[currentQuestion].answer) {
      setFeedback("Correct ✅");
      setScore(score + 1);
    } else {
      setFeedback("Wrong ❌");
    }
  };

  const handleNext = () => {
    setSelectedOption("");
    setFeedback("");

    if (currentQuestion + 1 < quizQuestions.length) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      setShowResult(true);
    }
  };

  const handleRestart = () => {
    setCurrentQuestion(0);
    setSelectedOption("");
    setFeedback("");
    setScore(0);
    setShowResult(false);
  };

  return (
    <div className="quiz-container">
      <h1>HTML Quiz</h1>

      {!showResult ? (
        <div className="question-section">
          <h2>Question {currentQuestion + 1}:</h2>
          <p className="question-text">{quizQuestions[currentQuestion].question}</p>

          <div className="options-section">
            {quizQuestions[currentQuestion].options.map((option, index) => (
              <div key={index} className="option-wrapper">
                <label
                  className={`option-label ${
                    selectedOption
                      ? option === quizQuestions[currentQuestion].answer
                        ? "correct"
                        : option === selectedOption
                        ? "wrong"
                        : ""
                      : ""
                  }`}
                >
                  <input
                    type="radio"
                    name="quizOption"
                    value={option}
                    checked={selectedOption === option}
                    onChange={() => handleOptionChange(option)}
                    disabled={!!selectedOption}
                  />
                  <span className="option-text">{option}</span>
                </label>
              </div>
            ))}
          </div>

          {selectedOption && <p className="feedback">{feedback}</p>}

          <button
            className="next-btn"
            onClick={handleNext}
            disabled={!selectedOption}
          >
            {currentQuestion + 1 === quizQuestions.length ? "Finish" : "Next"}
          </button>
        </div>
      ) : (
        <div className="result-section">
          <h2>Quiz Completed!</h2>
          <p>
            Your Score: {score} / {quizQuestions.length}
          </p>
          <button className="restart-btn" onClick={handleRestart}>
            Restart Quiz
          </button>
        </div>
      )}
    </div>
  );
};

export default HTML_Quiz;
